import { render, staticRenderFns } from "./liberacao-periodos.vue?vue&type=template&id=2534838d"
import script from "./liberacao-periodos.vue?vue&type=script&lang=js"
export * from "./liberacao-periodos.vue?vue&type=script&lang=js"
import style0 from "./liberacao-periodos.vue?vue&type=style&index=0&id=2534838d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports